import { render, staticRenderFns } from "./Tzqtrk.vue?vue&type=template&id=0edabe9c&scoped=true&"
import script from "./Tzqtrk.vue?vue&type=script&lang=js&"
export * from "./Tzqtrk.vue?vue&type=script&lang=js&"
import style0 from "./Tzqtrk.vue?vue&type=style&index=0&id=0edabe9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edabe9c",
  null
  
)

export default component.exports